export default __webpack_public_path__ + "static/media/Wolf Tamer's Blade.d7f0b732.jpg";